import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { PERMISSION_CONFIG_TOKEN } from '@/core/util/permission.token';
import { STORAGE_SERVICE_TOKEN } from '@/core/util/storage.token';
import { PERMISSION_SERVICE_TOKEN } from '@/core/util/permission-service.token';
import { STORAGE_KEYS } from '@/share/constant/storage_token.key';

export const authGuard: CanActivateFn = (route): boolean | UrlTree => {
    const ps = inject(PERMISSION_SERVICE_TOKEN);
    const storage = inject(STORAGE_SERVICE_TOKEN);
    const config = inject(PERMISSION_CONFIG_TOKEN);
    const router = inject(Router);

    // ❌ Not logged in → login
    if (!storage.get(STORAGE_KEYS.USER)) {
        return router.parseUrl('/auth/login');
    }

    // 🔓 Permission system disabled → allow
    if (!config.enabled) {
        return true;
    }

    // 🔐 RBAC metadata
    const feature = route.data?.['feature'];
    const action = route.data?.['action'];
    // 🟢 No permission metadata → allow
    if (!feature || !action) {
        return true;
    }

    const allowed = ps.has(String(feature).toUpperCase(), action.toUpperCase());

    if (!allowed) {
        return router.parseUrl('/403');
    }

    return true;
};
